var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function getJson(url, body) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchJson(url, { method: 'GET', body: body ? JSON.stringify(body) : undefined });
    });
}
export function postJson(url, body) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchJson(url, { method: 'POST', body: body ? JSON.stringify(body) : undefined });
    });
}
export function deleteJson(url, body) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield fetchJson(url, { method: 'DELETE', body: body ? JSON.stringify(body) : undefined });
    });
}
function fetchJson(url_1) {
    return __awaiter(this, arguments, void 0, function* (url, options = { method: 'GET' }) {
        try {
            const response = yield fetch(url, Object.assign(Object.assign({}, options), { headers: { 'Content-type': 'application/json' } }));
            try {
                return { json: (yield response.json()), status: response.status };
            }
            catch (err) {
                return { json: null, status: response.status };
            }
        }
        catch (err) {
            return { json: null, status: 400 };
        }
    });
}
//# sourceMappingURL=utils.js.map